import {
  useDataModel,
  params,
  string,
  id,
  shape,
  number,
  customType,
  arrayOf,
} from '@thd-nucleus/data-sources';

export function OnlineOrderDetails({ children, customerInfo, order }) {
  const variables = {
    customerAccountId: customerInfo?.customerAccountId,
    orderNumber: order?.orderNumbers?.[0],
    groupAndSortBy: {
      groupBy: 'fulfillmentType',
    },
    searchType: 'online'
  };

  const queryOptions = {
    variables: {
      userId: customerInfo?.userId,
      request: variables,
      headers: {
        tmxProfileId: customerInfo.sessionId,
        channelId: customerInfo.channelId,
      }
    },
    context: { withAuth: true },
  };

  const { data, loading, error } = useDataModel(
    'orderDetails',
    queryOptions
  );

  return children({ data, loading });
}

OnlineOrderDetails.dataModel = {
  orderDetails: params({
    userId: id().isRequired(),
    headers: customType('HeaderExtras').shape({
      tmxProfileId: string(),
      channelId: string()
    }),
    request: customType('OrderDetailsRequest!').shape({
      customerAccountId: string(),
      orderNumber: string(),
      searchType: string(),
      groupAndSortBy: shape({
        groupBy: string(),
      })
    }),
  }).shape({
    lineItems: arrayOf(
      shape({
        itemDescFromCatalog: string(),
        quantity: number(),
        imageUrl: string(),
        skuNumber: number()
      })
    ),
    statusDescription: string(),
  }),
};
